import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
import _ from 'lodash';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import {Snackbar, SnackbarContent} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import DataTable from './DataTable';

import {addAdminAnnouncement, getAdminReview, updateAdminCustomer, updateAdminReview, getAdminAnnouncements, updateAdminAnnouncementById, getAdminAnnouncementById, deleteAdminAnnouncementById} from '../../network';
import {formatDate, padding} from '../../utils/formatter';
import {capitalize} from '../../helpers/Helper';
import ReviewOverlayComponent from '../shared/ReviewOverlayComponent';
import CustomButton  from '../shared/CustomButton';
import PopUp from '../shared/CustomModal';
import Review from '../Customer Review/Review';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 14.75rem);
  height: 100vh;
  //height: 100%;
  
  padding: 1rem 1.5rem 0 1.5rem;
`;

const PageHeader = styled.h1`
  height: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.25rem;
  
  font-family: OpticianSans, serif;
  font-style: normal;
  font-weight: normal;
  
  color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: -webkit-fill-available;
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;
`;

const Tag = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-4) var(--space-6);

  font-size: var(--font-12);
  font-weight: 500;
  color: ${props => props.color ? `var(--color-${props.color}-800)` : ''};
  background-color: ${props => props.color ? `var(--color-${props.color}-100)` : ''};
  box-shadow: ${props => props.color ? `0 0 0 1px var(--color-${props.color}-300)` : '0 0 0 1px #C8E1D2'};
  border-radius: var(--space-4);
`;

const Label = styled.span`
  color: var(--color-gray-600);
  width: 6rem;
`;

const OrderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: var(--space-24);
  margin-right: var(--space-24);
  margin-bottom: var(--space-16);
  & > span:first-of-type {
    font-weight: 500;
    color: var(--company-dark);
  }
  & > span:last-of-type {
    color: var(--color-gray-700);
  }
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-bottom: 1rem;
  > a {
    color: var(--company-dark);
    font-weight: 500;
    width: 12.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:last-of-type {
      margin-bottom: var(--space-28); 
    }
`;

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  justify-content: space-between;
  padding-top: var(--space-16);
  padding-left: var(--space-20);
  padding-right: var(--space-20);
  padding-bottom: var(--space-8);
  border-top: 1px solid var(--color-gray-300);
  > button {
    border: none;
    box-shadow: none;
    background: none;
    padding: var(--space-6) var(--space-8);
    border-radius: var(--space-4);
    color: var(--company-dark);
    font-size: var(--font-16);
    font-weight: normal;
    &:hover {
      background-color: var(--color-gray-200);
      transition: background-color 0.3s ease-in;
    }
    &:last-of-type {
      color: var(--color-red-700);
    }
    &:disabled {
      color: var(--color-gray-500);
      cursor: not-allowed;
    }
  }
`;

const InnerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: calc(100% - var(--space-32));
  line-height: 1.2;
  vertical-align: center;
  font-size: var(--font-14);
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;

  background: white;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;

  padding: 0 1.5rem 0 1.5rem;

  justify-content: space-between;
  align-items: center;
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;

  > span {
    height: 0.875rem;

    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: var(--color-gray-600);
  }
`;

const Dropdown = styled.div`
  border: 1px solid var(--color-gray-300);
  box-sizing: border-box;
  border-radius: 1.5rem;
  
  margin: 0 0 0 1rem;
  padding: 0 0.75rem 0 0.75rem;
  
  > select {
    height: 1.5rem;
    
    background: transparent;
    
    border: 0;
  
    appearance: none;
    outline: none;

    
    font-size: 0.75rem;
    font-weight: 500;
    
    color: var(--color-gray-800);
  }
  
  > img {
    margin-left: var(--space-8);
  }
`;

const SearchSection = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  
  > img {
    position: relative;
    left: 90%;
  }
  
  > input {
    width: 100%;
    height: 1.875rem;
    
    padding: 1rem;
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 4px;
    
    color: var(--color-gray-500);
    
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

const CellText = styled.span`
  width: 90%;
  
  
  font-style: normal;
  //font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;

  color: var(--color-gray-900);
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Divider = styled.div`
  width: calc(100% - var(--space-48));
  margin-top: var(--space-8);
  margin-bottom: var(--space-24);
  margin-left: var(--space-24);
  height: 1px;
  background-color: var(--color-gray-300);
`;

const MasterContainer = styled.div`
  //height: -webkit-fill-available;
  height: calc(100vh - 2.5rem); // desperation
  flex-grow: 1;
  margin-right: 1.5rem;
`;

const DetailContainer = styled.div`
  width: 24rem;
  height: calc(100vh - 4.5rem); // desperation
`;
const DetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-top: 1rem;
  margin-bottom: 2rem;
  > span {

    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.375rem;

    color: var(--color-gray-900);
  }
`;
const useStyles = makeStyles({
    root: {
      width: 120,
      display: 'flex',
      alignItems: 'center',
    },
  });
function BackOfficeAnnouncements({auth}) {
    const classes = useStyles();
    const [addAnnouncement, setAddAnnouncement] = useState(false);
    const [deleteOneAnnouncement, setDeleteOneAnnouncement] = useState(false);
    const [updateOneAnnouncement, setUpdateOneAnnouncement] = useState(false);
    const [announcements, setAnnouncements] = useState([]);
    const [category, setCategory] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState({
        sortOrder: 'desc',
        sortBy: 'updatedAt'
    });
    const [filter, setFilter] = useState();
    const [details, setDetails] = useState(null);
    const [detailsEdit, setDetailsEdit] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(25);
    const [pageCount, setPageCount] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastText, setToastText] = useState('');

    const adminToken = auth ? auth.token : null;

    const filters = [
        {
            value: 'latest',
            text: 'Latest'
        },
        {
            value: 'lowest',
            text: 'Lowest Rating'
        },
        {
            value: 'highest',
            text: 'Highest Rating'
        },
        {
            value: 'Pending',
            text: 'Pending'
        },
        {
            value: 'Approved',
            text: 'Approved'
        }
    ];
    const headers = [
        {
            title: 'Post ID',
            sortable: true,
            sort: 'post_id'
        },
        {
            title: 'Title',
            sortable: true,
            sort: 'title'
        },
        {
            title: 'Description',
            sortable: true,
            sort: 'desc'
        },
        {
            title: 'Category',
            sortable: true,
            sort: 'category'
        },
        // {
        //     title: 'Rating',
        //     sortable: true,
        //     sort: 'rating'
        // },
        // {
        //     title: 'Status',
        //     sortable: true,
        //     sort: 'status'
        // }
    ];

    useEffect(() => search(searchText), [searchText,filter,sort]);
    

    const search = (searchText) => {
        getAdminAnnouncements(searchText)
            .then(result => {
                setDetails(null);
                setDetailsEdit(null);
                setAnnouncements([...result.data]);
                setPageCount(Math.ceil(result.total / pageLimit));
                
            })
            .catch(error => console.error(error));
    };

    const deleteAnnouncement = () => {
        deleteAdminAnnouncementById(details?._id)
            .then(res => {setToast(true); setToastText('Deleted'); search(searchText); setDeleteOneAnnouncement(false);})
            .catch(error => console.log(error));
    }

    const addNewAnnouncement = () => {
        const params = {title, desc: description, image, category };
        addAdminAnnouncement(params)
            .then(res => {setToast(true); setToastText('Added'); setAddAnnouncement(false); search(searchText);})
            .catch(err => console.log(err));
    }

    const changeSort = sort => setSort(sort);

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setAnnouncements([]);
        setCurrentPage(currentPage + (direction));
    };

    const debouncedSearchText = _.debounce(query => {
        setSearchText(query);
    }, 400);

    const handleSearchChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    };

    const onRowSelect = data => {
        getAdminAnnouncementById(data?._id)
            .then(result => {
                // let orders = [];
                // result.data.forEach(order => {
                //     orders.push({
                //         ticket: order.review_id,
                //         order_date: order.createdAt
                //     });
                // });

                // const details = {
                //     review: data,
                //     orders
                // };
                console.log(result);
                setDetails(result);
                setDetailsEdit(null);
            })
            .catch(error => console.error(error));
    };
    useEffect(() => { if (sort.sortBy !== 'updatedAt') onRowSelect(announcements[0])}, [announcements, sort]);
    const dataRows = data => {
        let rows = [];
        data.map(item => {
            rows.push({
                onRowSelect,
                data: item,
                view: <>
                    <CellText>{item.announcement_id}</CellText>
                    <CellText>{item.title}</CellText>
                    <CellText>{item.desc}</CellText>
                    <CellText>{item.category}</CellText>
                    {/* <CellText style={{
                        color: '#049CBE',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}>{item.email}</CellText> */}
                    {/* {item.active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>} */}
                </>
            });
        });
        return rows;
    };

    const handleEditChange = e => {
        const {value, name} = e.target;
        setDetailsEdit({
            ...detailsEdit,
            [name]: value
        });
    };

    const updateAnnouncement = () => {
        const params ={ title, desc: description, image, category }
        updateAdminAnnouncementById(details?._id, params )
            .then(result => {setAddAnnouncement(false); search(searchText); setToast(true); setToastText('Updated'); clearValues(); })
            .catch(error => console.error(error));
    }

    const clearValues = () => {
        setTitle('');
        setDescription('');
        setImage('');
        setCategory('');
        setUpdateOneAnnouncement(false);
    }

    const evalPrimaryAction = () => {
        // updateAdminAnnouncementById(details._id)
        //     .then(result => {search(searchText); setToast(true); })
        //     .catch(error => console.error(error));
        setAddAnnouncement(true);
        setTitle(details.title);
        setDescription(details.desc);
        setImage(details.image);
        setCategory(details.category);
        setUpdateOneAnnouncement(true);
        // if (!detailsEdit) setDetailsEdit({...details.customer});
        // else {
        //     // eval if valid information entered, collect updates and update customer
        //     updateReview(detailsEdit._id, detailsEdit)
        //         .then(result => search(searchText))
        //         .catch(error => console.error(error));
        // }
    };

    const evalSecondaryAction = () => {
        setDeleteOneAnnouncement(true);
    };

    const onFilterChange = (value) => {
        setFilter(value);
        if(value === 'highest'){
            setSort({
                sortOrder: 'desc',
                sortBy: 'rating'
            })
        }
        else if(value === 'lowest'){
            setSort({
                sortOrder: 'asc',
                sortBy: 'rating'
            })
        }
        else if(value === 'latest'){
            setSort({
                sortOrder: 'desc',
                sortBy: 'createdAt'
            })
        }
        else{
            setSearchText(value);
        }
    }

    const checked = () => {
        return title && description && image;
    }


    return (

        <Container>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={toast}
                autoHideDuration={5000}
                onClose={()=>setToast(false)}
                key={'toast'}
            >
                <SnackbarContent
                    style={{backgroundColor: '#02B2D9', minWidth: 'auto', borderRadius: '8px', border: '2px solid #049CBE'}}
                    message={<span id="client-snackbar">{`✓ Announcement Successfully ${toastText}`}</span>}
                />
            </Snackbar>
            <MasterContainer>
                { addAnnouncement && 
                    <>
                        <div style={{backgroundColor:'var(--color-gray-400)', opacity:'0.6', position:'absolute', zIndex: 10, top: 0, left:0, width: '100vw', height: '100vh'}}>
                            
                        </div>
                        <div style={{zIndex: 15, position: 'absolute', top: '20%', left: '40%'}}>
                            <PopUp 
                                type={'post'}
                                category={category}
                                title={title}
                                description={description}
                                image={image}
                                setCategory={setCategory}
                                setTitle={setTitle}
                                setDescription={setDescription}
                                setImage={setImage}
                                checked={checked} 
                                setCancel={setAddAnnouncement}
                                addOffer={addNewAnnouncement}
                                updateOffer={updateAnnouncement}
                                update={updateOneAnnouncement}
                            />
                        </div>
                    </>
                }
                {
                    deleteOneAnnouncement &&
                        <ReviewOverlayComponent setCancel={setDeleteOneAnnouncement} setConfirm={deleteAnnouncement}/>
                }
                <PageHeader>ANNOUNCEMENTS</PageHeader>
                <ContentContainer>
                    <Row style={{marginBottom: '1rem'}}>
                        {/* <FilterSection>
                            <span>Filter by</span>

                            <Dropdown>
                                <select value={filter} onChange={e => onFilterChange(e.target.value)}>
                                    <option value=''>All</option>
                                    {
                                        filters.map((filter, index) => {
                                            return <option key={`BackofficeReviewsFilterOption_${index}`} value={filter.value}>{filter.text}</option>;
                                        })
                                    }
                                </select>
                                <img alt='dropdown' src='/icons/chevron.svg'/>
                            </Dropdown>
                        </FilterSection> */}

                        <SearchSection>
                            <img src='/icons/search.svg' alt='search icon'/>
                            <input placeholder='Search here...' type='text' onChange={handleSearchChange}/>
                        </SearchSection>
                        <CustomButton name={"Add Announcement"} onClick={()=> {setAddAnnouncement(true); clearValues();}}/>
                    </Row>

                    <DataTable
                        headers={headers}
                        rows={dataRows(announcements)}
                        changeSort={changeSort}
                        spacing={'20% 20% 20% 20% 20%'}
                        currentPage={currentPage}
                        pageCount={pageCount}
                        pageBack={() => changePage(-1)}
                        pageNext={() => changePage(1)}
                    />
                </ContentContainer>
            </MasterContainer>

            {
                details && <DetailContainer>
                    <PageHeader>DETAILS</PageHeader>
                    <InnerDetailContainer>
                        <DetailHeader>
                            <span>{`Announcement ${details.announcement_id}`}</span>
                        </DetailHeader>
                        <DetailRow>
                            <div style={{width:'340px', borderRadius:'15px', overflow:'hidden', height:'192px'}}>
                                <img src={details.image} alt="preview" style={{objectFit:'cover', width:'100%', height: '100%'}}/>
                            </div>
                        </DetailRow>
                        <DetailRow>
                            <Label>Title:</Label>
                            <span>{details.title}</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Category:</Label>
                            <span>{details.category}</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Posted:</Label>
                            <span>{moment(details.createdAt).format("MMM DD, YYYY")}</span>
                        </DetailRow>
        
                        <Divider/>
                        <DetailRow>
                            <Label>Description:</Label>
                        </DetailRow>
                        <DetailRow>
                            <span style={{fontStyle:'italic'}}>{details.desc}</span>
                        </DetailRow>
                        
                        <ActionsBar>
                            <button onClick={evalPrimaryAction}>{'Edit'}</button>
                            <button onClick={evalSecondaryAction}>{'Delete'}</button>
                        </ActionsBar>
                    </InnerDetailContainer>
                </DetailContainer>
            }
        </Container>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(BackOfficeAnnouncements);
